import { lock, unlock } from 'tua-body-scroll-lock';

/**
 * Will keep scrollbar on element displayed if toggled once.
 * Can be used to fix native scrollbar toggling loop on Chrome.
 * Ex: slidepanel with swiper inside with slidepanel at the scroll threshold cause this issue
 * @param {Element} scrollContainerEl Potentially scrollable element
 * @return {IntersectionObserver} Observer created. Call disconnect() to stop the behavior
 */
export function keepScrollbarY(scrollContainerEl) {
    const hasScrollY = (el) => el.scrollHeight > el.clientHeight;

    const observer = new IntersectionObserver(() => {
        if (hasScrollY(scrollContainerEl)) {
            scrollContainerEl.style.overflowY = 'scroll';
            observer.disconnect();
        }
    }, {
        root: scrollContainerEl,
        rootMargin: '0px',
        threshold: 1
    });

    // Will trigger a scrollbar check if any child is out of "view"
    const children = Array.from(scrollContainerEl.children);
    children.forEach((child) => {
        observer.observe(child);
    });

    return observer;
}

/**
 * Get scrollable elements of sidebar for specific sidebars
 * @param {Element} rootElement container containing the scrollable element
 * @return {(Element|Array)} Element/Array of containing the scrollable(s) element for tua-body-scroll-lock to avoid blocking in theses element(s)
 */
export function getScrollablesSidebarElements(rootElement) {
    // generic scrollbar case
    var hasSlidePanel = rootElement.querySelector('.slide-panel');
    if (hasSlidePanel) return hasSlidePanel;
    return null; // should not happen (!)
}

/**
 * Kenzo specific wrapper around tua-body-scroll-lock lock
 * for sidebars to get right scrollable element
 * @param {Element} sidebarElement sidebar element
*/
export function kenzoSidebarLock(sidebarElement) {
    lock(getScrollablesSidebarElements(sidebarElement));
}

/**
 * Kenzo specific wrapper around tua-body-scroll-lock unlock
 * for sidebars to get right scrollable element
 * @param {Element} sidebarElement sidebar element
*/
export function kenzoSidebarUnlock(sidebarElement) {
    unlock(getScrollablesSidebarElements(sidebarElement));
}

export default {
    kenzoSidebarLock,
    kenzoSidebarUnlock,
    keepScrollbarY,
    getScrollablesSidebarElements
};
